module.exports = __webpack_public_path__ + "img/banner-font.96df332c.png";